var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6339 10.239C16.031 10.5324 16.1187 11.0972 15.83 11.5005L12.2744 16.4674C12.1298 16.6694 11.9092 16.8016 11.6652 16.8324C11.4211 16.8632 11.1754 16.7899 10.9865 16.63L8.31984 14.3723C7.9427 14.053 7.89175 13.4836 8.20603 13.1004C8.5203 12.7173 9.08081 12.6655 9.45794 12.9848L11.3952 14.6249L14.3922 10.4382C14.681 10.0349 15.2369 9.94567 15.6339 10.239Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8854 4.40437C11.5327 3.87008 12.4585 3.86472 13.1118 4.39148L15.5556 6.36218V5.09945C15.5556 4.6007 15.9535 4.19639 16.4444 4.19639C16.9354 4.19639 17.3333 4.6007 17.3333 5.09945V7.81234L19.3687 9.55703C19.769 9.90021 20 10.4053 20 10.9374V18.1939C20 19.1914 19.2041 20 18.2222 20H5.77778C4.79594 20 4 19.1914 4 18.1939V10.9477C4 10.4038 4.24124 9.88887 4.65672 9.5459L10.8854 4.40437ZM15.8814 8.93089L12.0065 5.80613L5.77778 10.9477V18.1939H18.2222V10.9374L15.8814 8.93089Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon_home.2b87020cf10d490c8461a518315cb307.svg";
export { ForwardRef as ReactComponent };